// import { routerMiddleware } from 'connected-react-router'; // Removed in v6
// import { History } from 'history'; // Removed in v6
import { applyMiddleware, createStore, Store } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import { Persistor } from 'redux-persist/es/types';
import thunk, { ThunkMiddleware } from 'redux-thunk';

import { ActionType } from './actionTypes';
import api, { ApiMiddleware } from './middlewares/api';
import logMiddleware from './middlewares/log';
import persistConfig from './persistConfig';
import { createRootReducer, State } from './state';
import { Action, AppReducer } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
const thunkMiddleware = thunk as ThunkMiddleware<State, Action<ActionType>>;

// eslint-disable-next-line @typescript-eslint/naming-convention
const apiMiddleware = api as ApiMiddleware<State, Action<ActionType>>;

// eslint-disable-next-line @typescript-eslint/naming-convention
const configureStore = (
  initialState: State = {},
): {
  store: Store<State>;
  persistor: Persistor;
} => {
  const appReducer: AppReducer = persistReducer(
    persistConfig,
    createRootReducer(),
  );

  const store = createStore(
    appReducer,
    initialState,
    applyMiddleware(
      logMiddleware,
      // routerMiddleware(history), // Removed in v6
      thunkMiddleware,
      apiMiddleware,
    ),
  );

  const persistor: Persistor = persistStore(store);

  return { store, persistor };
};

export default configureStore;
